/*
 * @Date: 2026-03-16 11:52:33
 * @LastEditors: ryan.zheng@momenta.ai
 * @LastEditTime: 2026-04-11 01:41:12
 */
// ─── Perms 服务（鉴权 / 用户）────────────────────────────────────────────────
export const API_PERMS_SMS_CODE     = '/api/perms/sms_code'; // 获取手机短信验证码
export const API_PERMS_EMAIL_CODE   = '/api/perms/email_code'; // 获取邮箱验证码
export const API_PERMS_LOGIN        = '/api/perms/login'; // 手机号 / 邮箱登录跳转（GET，由 window.location.href 发起）
export const API_PERMS_FEISHU_LOGIN = '/api/perms/feishu_login'; // 飞书 OAuth 回调（GET，作为飞书授权的 redirect_uri）
export const API_PERMS_USER         = '/api/perms/user'; // 获取当前登录用户信息（POST）
export const API_PERMS_LOGOUT       = '/api/perms/logout'; // 登出（POST，清空后端 session）
// ─── MRTC 平台 ────────────────────────────────────────────────────────────────
export const API_MRTC_LIVEKIT_TOKEN = '/api/v1/livekit/token'; // 获取 LiveKit 访问令牌
// ─── TosPilot（mn / pad / main 业务）────────────────────────────────────────
export const API_MN_GET_TEAMS_BY_SEAT        = '/api/tospilot/remote/get_operator_plan_by_seatid'; // 按 seatId 查询绑定的车队列表
export const API_MN_GET_SEAT_BY_SEATID       = '/api/tospilot/remote/get_seat_by_seatid'; // 按 seatId 查询驾舱详情
export const API_MN_TOGGLE_SEAT_STATUS       = '/api/tospilot/remote/toggle_seat_status'; // 切换驾舱状态
export const API_MN_SEAT_RELEASE             = '/api/tospilot/remote/seat_release'; // 释放驾舱
export const API_MN_SEAT_OCCUPY              = '/api/tospilot/remote/seat_occupy'; // 占用驾舱
export const API_MN_PAD_FETCH_CARLIST        = '/api/tospilot/remote/pad_fetch_carlist'; // 获取可调度车辆列表
export const API_MN_START_SYNC               = '/api/tospilot/remote/start_sync'; // 发起进同步驾驶请求
export const API_MN_NOTIFY_START_SYNC_RESULT = '/api/tospilot/remote/notify_start_sync_result'; // 上报进同步结果
export const API_MN_STOP_SYNC                = '/api/tospilot/remote/stop_sync'; // 发起退同步驾驶请求
export const API_MN_NOTIFY_STOP_SYNC_RESULT  = '/api/tospilot/remote/notify_stop_sync_result'; // 上报退同步结果
export const API_MN_NOTIFY_CLOUDORDER_RESULT = '/api/tospilot/remote/notify_cloudorder_result'; // 上报云决策结果
export const API_MN_PRO2ULTRA                = '/api/tospilot/remote/pro2ultra'; // Pro 升 Ultra
export const API_MN_NOTIFY_TICKET_RESULT     = '/api/tospilot/ticket/notify_ticket_result'; // 上报工单处理结果
// ─── 第三方 OAuth ─────────────────────────────────────────────────────────────
export const FEISHU_OAUTH_URL     = 'https://open.feishu.cn/open-apis/authen/v1/authorize'; // 飞书 OAuth 授权页地址
export const FEISHU_MMT_APP_ID    = 'cli_a4488d870e7cd00e'; // 飞书应用 App ID（MMT）
export const FEISHU_DRIVER_APP_ID = 'cli_a5b092d2677fd00d'; // 飞书应用 App ID（Driver）
export const FEISHU_VAN_APP_ID    = 'cli_a95dd6eb79bbdbce'; // 飞书应用 App ID（Driver）
